import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  supportedCustomerTypes: Yup.array()
    .min(1, 'Please select at least one customer type')
    .required('Selection is required'),
});
